import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useBackofficeAuth } from '../../hooks/useBackofficeAuth';
import { ROUTES } from '../../config/constants';
import LoadingSpinner from '../common/LoadingSpinner';

interface BackofficeRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

const BackofficeRoute: React.FC<BackofficeRouteProps> = ({ children, requiredRole }) => {
  const { user, loading, isAuthenticated } = useBackofficeAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    // Redirect to backoffice login page, preserving the attempted location
    return (
      <Navigate 
        to={ROUTES.BACKOFFICE_LOGIN} 
        state={{ from: location }} 
        replace 
      />
    );
  }

  if (requiredRole && user?.role !== requiredRole) {
    // User doesn't have required role
    return (
      <Navigate 
        to={ROUTES.BACKOFFICE_DASHBOARD} 
        replace 
      />
    );
  }

  return <>{children}</>;
};

export default BackofficeRoute;